/**
 * <video-row>
 *
 * A row of vertical videos. Each video autoplays muted and loops, but only while
 * it is on or near the screen — a wall of clips should never cost a wall of
 * decoding. Under prefers-reduced-motion nothing plays on its own and controls
 * appear so the video is still reachable.
 */
class VideoRow extends HTMLElement {
  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('video'));
    if (this.videos.length === 0) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.videos.forEach((video) => {
        video.autoplay = false;
        video.controls = true;
        video.pause();
      });
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            // Autoplay can be refused (low power mode, a policy change). Let it fail
            // quietly — the poster frame stays up and nothing breaks.
            video.play()?.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0 }
    );

    this.videos.forEach((video) => this.observer.observe(video));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('video-row')) {
  customElements.define('video-row', VideoRow);
}
